import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'

const service = 'account/onboarding'

export const readOnboarding = () => (dispatch, getState) => {
  dispatch({ type: ActionType.Onboarding.READ_REQUEST })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/${service}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res => res.json())
        .then(
          payload => {
            if (
                
              payload && payload.notOk
            ) {
              dispatch({
                type: ActionType.Onboarding.READ_FAILURE,
                payload,
                notOk: true,
              })
              return
            }

            dispatch({
              type: ActionType.Onboarding.READ_SUCCESS,
              payload,
            })
            return payload
          },
          error =>
            dispatch({
              type: ActionType.Onboarding.READ_FAILURE,
              payload: error,
            })
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const toggleExpansionPanel = (payload = null) => dispatch =>
  dispatch({ type: ActionType.Onboarding.TOGGLE_EXPANSION_PANEL, payload })